<template>
  <div>
    <logoBar :pre="prependSrc" :brandExperience="brandContext" />
    <hero :pre="prependSrc" :brandExperience="brandContext" @active="getActive($event)" />
    <div class="wrapper-bg">
      <retailers :pre="prependSrc" :active="active" />
      <arrowAnim :pre="prependSrc" />
      <intro2 :pre="prependSrc" />
      <carouselFull :pre="prependSrc"
        @activeRecipe="getActiveRecipe($event)"
        :brandExperience="brandContext"
      />
      <!--pass a variation value to determine the style of component-->
      <intro :pre="prependSrc" />
      <carousel :pre="prependSrc" :iteration="'1'" :brandExperience="brandContext" />
      <csModal :pre="prependSrc" :brandExperience="brandContext" />

      <recipeModal :pre="prependSrc"
        :brandExperience="brandContext"
        :activeRecipe="activeRecipe"
      />
      <terms />
    </div>
  </div>
</template>

<script setup>
import channelsightWidget from "./js/channelsight-widget.js";
import dataModel from "./js/model.js";
import hero from "./components/hero.vue";
import csModal from "./components/csModal.vue";
import intro from "./components/intro.vue";
import arrowAnim from "./components/arrowAnim.vue";
import intro2 from "./components/intro2.vue";
import logoBar from "./components/logoBar.vue";
import retailers from "./components/retailers.vue";
import carousel from "./components/carousel.vue";
import terms from "./components/terms.vue";
import carouselFull from "./components/carouselFull.vue";
import recipeModal from "./components/recipeModal.vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
//invoke the channelsight widget, if needed
channelsightWidget();

//grab URL parameter to determine experience
let params = new URLSearchParams(document.location.search);
let brandContextParam = params.get("brandContext");

//parse URL parameter ready to pass to component
var brandContext =
  !brandContextParam == "" && brandContextParam <= Object.keys(dataModel).length
    ? (brandContext = brandContextParam)
    : console.log("Generating experience " + brandContextParam);

var prependSrc = '/captainmorgan/'
</script>
<script>
export default {
  data() {
    return {
      active: 1,
      activeRecipe: 1,
    };
  },
  methods: {
    getActive(data) {
      this.active = data;
    },
    getActiveRecipe(data) {
      this.activeRecipe = data;
    },
  },
};
</script>

<style>
body {
  margin: 0;
}
.wrapper-bg {
  position: relative;
  background: url("/public/hero/Red_bg_desktop.jpg");
  z-index: 10;
  background-repeat: repeat;
  background-size: 100% auto;
}
#app {
  width: 100vw;
  overflow: hidden;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
::-webkit-scrollbar {
  display: none;
}
</style>
